const testimonials = [
  {
    quote:
      "I pulled 60 looks for a Paris shoot in an afternoon. Last year the same pull took two assistants and most of a week.",
    name: "Amelia Hart",
    role: "Senior Wardrobe Manager",
    company: "Private celebrity styling team",
  },
  {
    quote:
      "I finally stopped waking up at 3am wondering where the Chanel archive pieces were. They're where the app says they are.",
    name: "Marcus Lin",
    role: "Stylist & Archive Consultant",
    company: "Independent",
  },
  {
    quote:
      "My clients can browse their own wardrobes from their phone in the back of a car. That alone justifies the subscription.",
    name: "Priya Shah",
    role: "Founder",
    company: "Shah Styling Studio",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      aria-labelledby="testimonials-heading"
      className="py-20 md:py-28 bg-charcoal text-ivory"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14 md:mb-20">
          <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood-soft font-medium mb-5">
            — From the wardrobe room
          </p>
          <h2
            id="testimonials-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-balance"
          >
            Built with the people who already do this for a living.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-ivory/10 border border-ivory/10">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="bg-charcoal p-8 lg:p-10 flex flex-col"
            >
              <span
                aria-hidden
                className="font-display text-5xl text-oxblood leading-none mb-4"
              >
                "
              </span>
              <blockquote className="font-display text-lg md:text-xl leading-snug text-ivory/95 flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-ivory/15">
                <p className="font-medium text-sm text-ivory">{t.name}</p>
                <p className="text-xs text-ivory/60 mt-1">
                  {t.role} · {t.company}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
